import { Icon } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { removeBoardMembership } from "../../../../models/board";
import { ModalProps } from "../../ModalManager";
import { ConfirmModal } from "../ConfirmModal";

export type ConfirmUnsubscribeBoardModalProps = {
  boardUid: string;
  userUid: string;
} & ModalProps;

export function ConfirmUnsubscribeBoardModal({ ...props }: ConfirmUnsubscribeBoardModalProps) {
  const { t } = useTranslation();

  const handleOnClick = async () => {
    removeBoardMembership(props.boardUid, props.userUid);
    props.closeModal();
  }

  return (
    <ConfirmModal
      title={t("warning")}
      subtitle={t("modal.unsubscribe.subtitle")}
      description={t("modal.unsubscribe.description")}
      closeModal={props.closeModal}
      onConfirm={handleOnClick}
      confirmButtonText={t("modal.unsubscribe.confirm")}
    >
      <Icon color="warning" size="medium">
        <i className="icon-eye-off is-large" aria-hidden="true"></i>
      </Icon>
    </ConfirmModal>
  )
}
